import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation Update($data: UpdateColligateInput!) {
    updateColligate(data: $data) {
      id
    }
  }
`);

export const responseUpdateKey = "updateColligate";
export interface UpdateGql {
  updateColligate: {
    id: number;
  };
}
